import { Injectable } from "@angular/core";
import { WizardFlowContext } from "../../../wizard-flow-context.model";
import { GenericStepFactory } from "./generic-step.factory";
import { NextStepDeciderFactory } from "./next-step-decider.factory";
import { ICreateStep } from "./step-factory.interface";
import { IncomeStep } from "../../income-step.model";
import { IncomeStepConfig } from "../income-step-config.model";

@Injectable()
export class IncomeStepFactory extends GenericStepFactory<IncomeStep> implements ICreateStep {

  constructor(nextStepDeciderFactory: NextStepDeciderFactory) {
    super(nextStepDeciderFactory, IncomeStep);
  }

  // Income action labels now live only on IncomeStepConfig (read/written via config in the
  // component). No per-label copying needed — base create/configure handle title/_i18n/etc.
  create(config: IncomeStepConfig, wizardFlowContext: WizardFlowContext): IncomeStep {
    return super.create(config, wizardFlowContext);
  }

  configure(step: IncomeStep, config: IncomeStepConfig): void {
    super.configure(step, config);
  }
}
